import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {isSupervisor} from 'core/utils';
import userQuery from 'graphql/queries/user.gql';
import Spinner from 'components/spinner';
import styles from './styles.css';

@graphql(userQuery, {name: 'userData'})
@autobind
export default class SectionBanner extends Component {
    componentWillMount() {
        const availableCrops = this.props.userData.user.createDealerOrders
            ? ['soy', 'wheat', 'corn', 'sunflower']
            : ['soy', 'wheat'];

        const index = Math.floor(Math.random() * availableCrops.length);
        this.banner = availableCrops[index];
    }

    render() {
        if (this.props.userData.loading) return <Spinner />;
        if (isSupervisor(this.props.userData.user)) return null;
        return (
            <div className={classNames(styles.root, styles[`banner-${this.banner}`])}>
                <p className={styles.text}>{this.props.userData.user.organization.name}</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/section-banner/index.js